
function getRandom(min, max) {
    return Math.random() * (max - min) + min;
}


export function displayCollage(images) {
    images.forEach(img => {
        img.top = getRandom(0, 80);   
        img.left = getRandom(0, 80); 
        img.width = getRandom(100, 400);
        
        if (img.src === '/HomePage/line1.jpg') {
          img.style = {
            mixBlendMode: 'multiply',
          };
        }

        if (img.src.includes('star')) {
          img.class = "rotate";
        }
      });
      


}




